<script setup lang="ts">
defineProps<{
  title: string
  skills: string[]
  color: 'blue' | 'purple' | 'green'
}>()
</script>

<template>
  <div class="space-y-2">
    <h3 class="font-medium text-gray-900 text-sm">
      {{ title }}
    </h3>
    <div class="flex flex-wrap gap-2">
      <span
        v-for="(skill, idx) in skills"
        :key="idx"
        class="px-2 py-1 rounded-md text-xs font-medium"
        :class="{
          'bg-blue-100 text-blue-800': color === 'blue',
          'bg-purple-100 text-purple-800': color === 'purple',
          'bg-green-100 text-green-800': color === 'green'
        }"
      >
        {{ skill }}
      </span>
    </div>
  </div>
</template>
